export const openLink = (url) => window.open(url, "_blank")?.focus();
